import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getEmails } from '../../../api';
import useRouteStore from '../../../hooks/useRouteStore';
import Table from '../../../common/Table';

const columns = [
  {
    key: 'from',
    title: 'De',
    sortable: true,
  },
  {
    key: 'to',
    title: 'Para',
    sortable: true,
    mutator: (v) => (Array.isArray(v) ? v.join(', ') : v ?? '—'),
  },
  {
    key: 'subject',
    title: 'Asunto',
    sortable: true,
  },
  {
    key: 'bodyCode',
    title: 'Plantilla',
    sortable: true,
    width: '140px',
  },
  {
    key: 'sentAt',
    title: 'Enviado',
    sortable: true,
    width: '130px',
    mutator: (v) => (v ? new Date(v).toLocaleString() : '—'),
  },
  {
    key: 'openedAt',
    title: 'Abierto',
    sortable: true,
    width: '130px',
    mutator: (v) =>
      v ? (
        <span className='inline-flex items-center gap-1 text-xs font-semibold text-green-700'>
          <svg className='w-3.5 h-3.5' fill='none' viewBox='0 0 24 24' stroke='currentColor' strokeWidth={2.5}>
            <path strokeLinecap='round' strokeLinejoin='round' d='M5 13l4 4L19 7' />
          </svg>
          {new Date(v).toLocaleString()}
        </span>
      ) : (
        <span className='inline-flex items-center gap-1 text-xs font-semibold text-gray-400'>
          <svg className='w-3.5 h-3.5' fill='none' viewBox='0 0 24 24' stroke='currentColor' strokeWidth={2.5}>
            <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
          </svg>
          No abierto
        </span>
      ),
  },
];

const Emails = () => {
  const [emails, setEmails] = useState([]);
  const [maxPage, setMaxPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState('');
  const [sortBy, setSortBy] = useState('');
  const [sortOrder, setSortOrder] = useState('');
  const [page, setPage] = useState(1);

  const setRoute = useRouteStore((state) => state.setRoute);

  useEffect(() => {
    setRoute([
      { name: 'Inicio', url: '/administracion' },
      { name: 'Correos', url: '/administracion/correos' },
    ]);
  }, []);

  useEffect(() => {
    setLoading(true);
    getEmails({ page, search: query, sortBy, sortOrder }).then((res) => {
      setEmails(res.data.messages ?? res.data.emails ?? res.data);
      setMaxPage(res.data.maxPage ?? 1);
      setLoading(false);
    });
  }, [page, query, sortBy, sortOrder]);

  const handleSearch = (q) => {
    setQuery(q);
    setPage(1);
  };

  const handleChangePage = (zeroBasedPage) => {
    setPage(zeroBasedPage + 1);
  };

  const handleSort = (key, dir) => {
    setSortBy(key ?? '');
    setSortOrder(dir ?? '');
    setPage(1);
  };

  return (
    <div className='font-montserrat w-full'>
      <div className='flex items-center justify-between pb-1 mb-3 border-b-2'>
        <h1 className='font-semibold text-xl'>Correos enviados</h1>
        <Link
          to='/administracion/correos/listas'
          className='flex items-center gap-1.5 border border-red-1 text-red-1 hover:bg-red-1 hover:text-white text-sm font-semibold px-3 py-1.5 rounded-lg transition-colors'
        >
          <svg className='w-4 h-4' fill='none' viewBox='0 0 24 24' stroke='currentColor' strokeWidth={2}>
            <path strokeLinecap='round' strokeLinejoin='round' d='M17 20h5v-2a4 4 0 00-5-3.87M9 20H4v-2a4 4 0 015-3.87m6-4a4 4 0 11-8 0 4 4 0 018 0zm6 4a4 4 0 00-3-3.87' />
          </svg>
          Listas de contacto
        </Link>
      </div>
      <Table
        ajax
        data={emails}
        columns={columns}
        loading={loading}
        elementsPerPage={20}
        maxPage={maxPage}
        onChangePage={handleChangePage}
        onSort={handleSort}
        tools={['search']}
        onSearch={handleSearch}
      />
    </div>
  );
};

export default Emails;
